import { Button, FormControl, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { isFulfilled } from "@reduxjs/toolkit";
import { useTranslation } from "react-i18next";

import useMessage from "../../../hooks/useMessage";
import { ExpenseTypesGrid } from "./ExpenseTypesGrid";
import { useAppDispatch } from "../../../app/hooks";
import { ExpenseType, ExpenseTypeMapping } from "../settingsApi";
import {
  addExpenseTypes,
  fetchExpenseTypeMappingsForDate,
} from "../settingsActions";
import { reduceExpenseTypes } from "../helpers/utils";

type Props = {
  selectedExpenseTypeMapping: string;
  closeView: () => void;
};

export const CreateExpenseTypeMapping = ({
  selectedExpenseTypeMapping,
  closeView,
}: Props) => {
  const dispatch = useAppDispatch();
  const { sendMessage } = useMessage();
  const { t } = useTranslation();

  const [expenseTypes, setExpenseTypes] = useState<ExpenseType[]>([]);

  const saveExpenseTypes = (expenseTypes: ExpenseType[]) => {
    const array = reduceExpenseTypes(expenseTypes);
    const newExpenseTypes: ExpenseTypeMapping = {
      validFrom: selectedExpenseTypeMapping,
      expenseTypes: array,
    };
    dispatch(addExpenseTypes(newExpenseTypes)).then(
      (action) => isFulfilled(action) && closeView(),
    );
  };

  useEffect(() => {
    if (selectedExpenseTypeMapping !== "") {
      dispatch(
        fetchExpenseTypeMappingsForDate({ date: selectedExpenseTypeMapping }),
      ).then((action) => {
        if (isFulfilled(action)) {
          setExpenseTypes(action.payload.expenseTypes);
          sendMessage(t("FETCH_SUCCESS"), "success");
        }
      });
    }
    // TODO fix sendMessage triggering infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, selectedExpenseTypeMapping, dispatch]);

  return (
    <>
      <h2>{t("addNewExpenseType", { ns: "settings" })}</h2>
      <Button variant="outlined" sx={{ marginBottom: 3 }} onClick={closeView}>
        {t("cancel")}
      </Button>
      <FormControl fullWidth>
        <h4>{t("effectiveFrom", { ns: "settings" })}</h4>
        <TextField value={selectedExpenseTypeMapping} label={null} disabled />
      </FormControl>
      <ExpenseTypesGrid expenseTypes={expenseTypes} onSave={saveExpenseTypes} />
    </>
  );
};
